import { useGET } from '../shared/hooks';
import QueryString from '../../lib/QueryString';

const toUrl = (seasonId, teamId, query) =>
  `/stats/season/${seasonId}/team/${teamId}${query}`;

export function useAdvancedStats(
  leagueId,
  seasonId,
  teamId,
  stageId,
  gameIds,
  playerSort,
  division,
  conference,
) {
  const query = getQuery(
    leagueId,
    stageId,
    gameIds,
    playerSort,
    division,
    conference,
  );
  const url = toUrl(seasonId, teamId, query);

  return useGET(url);
}

const getQuery = (
  leagueId,
  stageId,
  gameIds,
  playerSort,
  division,
  conference,
) => {
  const query = new QueryString();
  query.addValue('league_id', leagueId);
  if (stageId) query.addValue('stage_id', stageId);
  if (gameIds) query.addValue('games', gameIds);
  if (playerSort) query.addValue('player_sort', playerSort);
  if (conference) query.addValue('conference', conference);
  if (division) query.addValue('division', division);
  return query.toString();
};
